import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import {
	TableCell,
	TableRow,
	IconButton,
	Typography,
	Slide,
	Tooltip,
	Grow,
} from '@material-ui/core/';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import clsx from 'clsx';
import PostAddIcon from '@material-ui/icons/PostAdd';
import { displayedHeadersPropType } from 'proptypes/index';
import LaunchOutlinedIcon from '@material-ui/icons/LaunchOutlined';
import tableStyle from 'styles/tables';
import { formatDate } from 'utils/helpers';
import ErrorIcon from '@material-ui/icons/Error';

const formatValue = (header, row) => {
	let retVal;
	//const truncateLength = header.displayedLength || 64;

	switch (header.type) {
		case 'boolean':
			retVal = row[header.key] ? (
				<div style={{ color: 'green', fontSize: '2rem' }}>
					<FontAwesomeIcon icon="check" />
				</div>
			) : (
				<div style={{ color: 'red', fontSize: '2rem' }}>
					<FontAwesomeIcon icon="times" />
				</div>
			);
			break;
		//TODO add date formatter based on API
		default:
			retVal = row[header.key];
			break;
	}
	/* return retVal && retVal.length > truncateLength
		? retVal.substring(0, truncateLength) + '...'
		: retVal; */
	return retVal;
};

const genKey = () => {
	var d = new Date();
	var n =  d.getTime();

	let chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

	let str = '';
	for (let i = 0; i < 4; i++) {
		str += chars.charAt(Math.floor(Math.random() * chars.length));
	}

	str = str + n.toString();
	return str;
}


const Row = (props) => {
	const tableClasses = tableStyle();

	const { row
			, displayedHeaders
			, path
			, index
			, enableSelect
			, selectedValue
			, enableRawEdit
			, selectedRawEdit
			, enableFormEdit
			, selectedFormEdit
			, queryParameters
		} = props;

	return (
		<Fragment>
			<Slide in={true} {...(true ? { timeout: 100 * (index + 1) } : {})}>
				<TableRow className={tableClasses.tableRow}>
					<Tooltip
						arrow
						title={
							<div>
								{`Created By: ${row.createdBy} on ${formatDate(
									row.createdDate
								)}`}
								<br />
								{`Updated By: ${row.updatedBy} on ${formatDate(
									row.updatedDate
								)}`}
							</div>
						}
					>
						<TableCell
							className={clsx(
								tableClasses.tableCell,
								row.inactive && tableClasses.inactive
							)}
						>
							<ErrorIcon color="primary"/>
						</TableCell>
					</Tooltip>
					{displayedHeaders.map((header, index) => (
						<Tooltip
							key={`table_row_${index}_${header.key}`}
							title={
								header.displayedLength && row[header.key] ? row[header.key] : ''
							}
							placement="bottom-start"
							arrow
							TransitionComponent={Grow}
							TransitionProps={{ timeout: 600 }}
						>
							<TableCell
								className={clsx(
									tableClasses.tableCell,
									row.inactive && tableClasses.inactive
								)}
								style={{
									maxWidth:
										header.displayedLength && header.displayedLength * 3,
								}}
							>
								{formatValue(header, row)}
							</TableCell>
						</Tooltip>
					))}
					{
						enableFormEdit === true ? 
						<TableCell
							className={clsx(
								tableClasses.tableCell,
								row.inactive && tableClasses.inactive
							)}
							key={`table_row_${genKey()}_actions_column1`}
						>
							<IconButton
								key={`table_row_${genKey()}_actions_button1`}
								variant="contained"
								color="primary"
								component={Link}
								to={path.charAt(path.length -1) === '/' ? `${path}${row.idMaster}` : `${path}/${row.idMaster}`}
							>
								
								<LaunchOutlinedIcon />
							</IconButton>
						</TableCell>
						: null
					}
					
					{
						enableSelect === true ? 
						<TableCell
							className={clsx(
								tableClasses.tableCell,
								row.inactive && tableClasses.inactive
							)}
							key={`table_row_${genKey()}_actions_column2`}
						>
						<IconButton
							key={`table_row_${genKey()}_actions_button2`}
							variant="contained"
							color="primary"
							
							onClick={()=>selectedValue(row)}
							
						>
							<PostAddIcon color="primary"/>
							
						</IconButton>
						</TableCell>
						:
						null
					}
					{
						enableRawEdit === true ? 
						<TableCell
							className={clsx(
								tableClasses.tableCell,
								row.inactive && tableClasses.inactive
							)}
							key={`table_row_${genKey()}_actions_button3`}
						>
						<IconButton
							key={`table_row_${genKey()}_actions_button3`}
							variant="contained"
							color="secondary"
							
							onClick={()=> selectedRawEdit(row, queryParameters)}
							
						>
							<LaunchOutlinedIcon color="primary"/>
							
						</IconButton>
						</TableCell>
						:
						null
					}
				</TableRow>
			</Slide>
		</Fragment>
	);
};

Row.propTypes = {
	row: PropTypes.object.isRequired,
	displayedHeaders: displayedHeadersPropType.isRequired,
	path: PropTypes.string.isRequired,
	index: PropTypes.number.isRequired,
};

export default Row;
